import { NgModule } from '@angular/core';
import { GalleryService } from './gallery.service';
import { GalleryMarkupComponent } from './gallery-markup.component';

@NgModule({
  declarations: [GalleryMarkupComponent],
  providers: [GalleryService],
  exports: [GalleryMarkupComponent]
})
export class GalleryModule {}
